import { z } from 'zod'

// ============================================
// 基本信息表单 Schema
// ============================================
export const profileFormSchema = z.object({
	nickname: z
		.string()
		.min(1, { message: '请输入昵称' })
		.max(50, { message: '昵称最多 50 个字符' }),

	phone: z
		.string()
		.regex(/^1[3-9]\d{9}$/, { message: '请输入有效的手机号' })
		.optional()
		.or(z.literal('')),

	email: z
		.string()
		.email({ message: '请输入有效的邮箱地址' })
		.optional()
		.or(z.literal('')),

	avatar: z.string().optional(),
})

export type ProfileFormData = z.infer<typeof profileFormSchema>

// ============================================
// 修改密码表单 Schema
// ============================================
export const passwordFormSchema = z
	.object({
		old_password: z.string().min(1, { message: '请输入当前密码' }),
		new_password: z
			.string()
			.min(6, { message: '新密码至少 6 个字符' })
			.max(32, { message: '新密码最多 32 个字符' }),
		confirm_password: z.string().min(1, { message: '请确认新密码' }),
	})
	.refine((data) => data.new_password === data.confirm_password, {
		message: '两次输入的密码不一致',
		path: ['confirm_password'],
	})

export type PasswordFormData = z.infer<typeof passwordFormSchema>
